import React from 'react';
import T from 'prop-types';
import { _ } from '@splunk/ui-utils/i18n';
import Heading from '@splunk/react-ui/Heading';
import Markdown from '@splunk/react-ui/Markdown';
import styled from 'styled-components';

const Encoding = styled.div`
    margin-top: 20px;
`;
const EncodingName = styled.div`
    color: #5ca300;
    padding-bottom: 5px;
`;
const PairContainer = styled.div`
    margin-left: 40px;
    margin-top: 10px;
`;
const PairTitle = styled.span`
    display: inline-block;
    color: #8293a7;
    width: 80px;
`;

const Pair = ({ title, text }) => (
    <PairContainer>
        <PairTitle>{`${title}:`}</PairTitle>
        <span>{text}</span>
    </PairContainer>
);

Pair.propTypes = {
    title: T.string,
    text: T.string,
};

const EncodingItem = ({ name, type, desc, defaultValue, isRequired }) => (
    <Encoding>
        <EncodingName>{name}</EncodingName>
        <Markdown style={{ marginLeft: 40 }} text={desc} />
        <Pair title={_('Type')} text={type} />
        {defaultValue && <Pair title={_('Default')} text={defaultValue} />}
        <Pair title={_('isRequired')} text={isRequired} />
    </Encoding>
);

EncodingItem.propTypes = {
    name: T.string,
    type: T.string,
    desc: T.string,
    defaultValue: T.string,
    isRequired: T.string,
};

const EncodingDoc = ({ encoding }) => (
    <div>
        {encoding.length === 0 ? (
            <Heading level={4}> No Encoding</Heading>
        ) : (
            <Heading level={4}>Encoding</Heading>
        )}
        <div>
            {_(`Encoding specifies which and what type of datasources and fields are supported for visualization.
                Type of each encoding indicates the expected data type returned by the datasource for visualization.
                Default indicates the default datasource and field for visualization if encoding is not specified.
                Checking Examples tab on how to use encoding to specify datasource in each visualization.`)}
        </div>
        {encoding.map(d => (
            <EncodingItem key={d.name} {...d} />
        ))}
    </div>
);

EncodingDoc.propTypes = {
    encoding: T.array.isRequired,
};

export default EncodingDoc;
